// Notifications — the navbar inbox. Rows are written server-side when a
// scrape the user triggered completes/fails (extensible to sponsor outreach),
// so they survive sign-outs and page closes.
import apiConfig from '../config/apiConfig';

export interface AppNotification {
  id: string;
  type: string; // "scrape_complete" | "scrape_failed" | future kinds
  title: string;
  body: string;
  link: string | null;
  read: boolean;
  created_at: string | null;
}

export interface NotificationsResponse {
  notifications: AppNotification[];
  unread_count: number;
}

const headers = (token: string) => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${token}`,
});

export async function getNotifications(token: string): Promise<NotificationsResponse> {
  const res = await fetch(`${apiConfig.baseUrl}/api/notifications`, {
    headers: headers(token),
  });
  if (!res.ok) throw new Error(`Notifications fetch failed: ${res.status}`);
  return res.json();
}

export async function markNotificationsRead(
  token: string,
  opts: { ids?: string[]; all?: boolean },
): Promise<void> {
  const res = await fetch(`${apiConfig.baseUrl}/api/notifications/read`, {
    method: 'POST',
    headers: headers(token),
    body: JSON.stringify({ ids: opts.ids ?? [], all: opts.all ?? false }),
  });
  if (!res.ok) throw new Error(`Mark read failed: ${res.status}`);
}

// ── Active scrapes (platform-wide, powers the live scraping tiles) ──────
export interface ActiveScrape {
  platform: string;
  handle: string;
  kind: string;
  job_id: string;
  started_at: string | null;
  is_mine: boolean;
  progress: { percentage_complete: number; status_message: string } | null;
  /** Display name at kickoff (backend sends it once deployed; may be
   *  absent from older payloads). */
  name?: string | null;
}

export async function getActiveScrapes(token: string): Promise<ActiveScrape[]> {
  const res = await fetch(`${apiConfig.baseUrl}/api/data/active-scrapes`, {
    headers: headers(token),
  });
  if (!res.ok) throw new Error(`Active scrapes fetch failed: ${res.status}`);
  const data = await res.json();
  return data.scrapes || [];
}
